<template>
  <router-link class="nav-link" :to="to" v-bind="$attrs">
    <div
      class="mx-2 q-nav-icon icon icon-shape icon-sm border-radius-md d-flex align-items-center justify-content-center"
      :class="this.$store.state.isRTL ? ' ms-2' : 'me-2'"
    >
      <slot name="icon"></slot>
    </div>
    <span
      class="nav-link-text d-flex align-items-center gap-1"
      :class="this.$store.state.isRTL ? ' me-1' : 'ms-1'"
    >
      {{ navText }}
      <span v-if="badge > 0" class="nav-badge">{{ badge }}</span>
    </span>
  </router-link>
</template>
<script>
export default {
  name: "sidenav-collapse",
  props: {
    to: {
      type: [Object, String],
      required: true,
    },
    navText: {
      type: String,
      required: true,
    },
    badge: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
};
</script>

<style scoped>
.q-nav-icon {
  background: var(--q-hover);
  box-shadow: none;
  color: var(--q-muted);
}
.router-link-active .q-nav-icon,
a:hover .q-nav-icon {
  background: rgba(245, 166, 35, 0.12);
  color: var(--q-gold);
}
.nav-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #dc3545;
  color: #fff;
  font-size: 0.65rem;
  font-weight: 700;
  min-width: 18px;
  height: 18px;
  border-radius: 9px;
  padding: 0 4px;
  line-height: 1;
  flex-shrink: 0;
}
</style>
